module.exports = __webpack_public_path__ + "static/media/banner1.579bd31f.jpg";